import { getDateFnsLocale, format, formatDateFromYYYYMMDD } from "@/utils/date";
import { useLocale } from "./useLocale";

export function useDateFormatter() {
  const [locale] = useLocale();

  const formatWrapper = (
    date: string | Date,
    dateFormat: string,
    timeZone?: string
  ) =>
    format(date, dateFormat, timeZone, {
      locale: getDateFnsLocale(locale),
    });

  const formatDateFromYYYYMMDDWrapper = (
    yyyymmdd: string,
    dateFormat: string
  ) =>
    formatDateFromYYYYMMDD(yyyymmdd, dateFormat, {
      locale: getDateFnsLocale(locale),
    });

  return {
    format: formatWrapper,
    formatDateFromYYYYMMDD: formatDateFromYYYYMMDDWrapper,
  };
}
